/**
 * BONQUERÉ — Cookie Settings control  (BNQ-WEB-0617 · Sprint 3.4.18)
 *
 * Upgrades any `[data-bnq-cookie-settings]` element into a control that reopens Shopify's NATIVE
 * consent-preference interface. No second consent manager is installed and no CMP is implemented
 * here — this only calls the API the platform already provides.
 *
 * ── PROGRESSIVE ENHANCEMENT, NOT A DEPENDENCY ────────────────────────────────────────────────────
 * The element is authored as a real `<a>` whose href is DERIVED from a published Shopify policy —
 * `shop.privacy_policy.url` (falling back to the first published policy) with the
 * `#shopifyReshowConsentBanner` fragment appended. This script only intercepts when
 * `window.privacyBanner.showPreferences` actually exists, which is the better outcome (the granular
 * preference dialog rather than the banner). If the script never runs, the API is absent, or
 * JavaScript is disabled, the href navigates and the visitor still reaches consent settings.
 *
 * ── CORRECTION (BNQ-WEB-0943 · Sprint 3.4.22 · F-33) ─────────────────────────────────────────────
 * This comment previously claimed the href was `/policies/#shopifyReshowConsentBanner` and that the
 * route "is present in shop.policies on this store". That was FALSE and had been shipping in the
 * footer of every page: `/policies/` (the policy INDEX) returns 404 here, while each individual
 * policy returns 200. So the no-JS fallback — the entire reason this element is an anchor rather
 * than a button — led to a dead end, and crawlers followed a 404 from every page of the site.
 * The href is now derived in Liquid from a policy that actually exists. Do not reintroduce a
 * hardcoded '/policies/' URL here or in the two Liquid call sites.
 *
 * Keyboard and touch need no special handling: an anchor fires `click` on Enter and on tap, so one
 * delegated `click` listener covers mouse, touch and keyboard alike.
 *
 * ── ONE DELEGATED LISTENER, HOWEVER MANY CONTROLS ────────────────────────────────────────────────
 * Two components render this control (the footer LEGAL column and the Impressum's legal-links row),
 * and each emits its own `<script src>` tag. Browsers de-duplicate by URL, but the Theme Editor can
 * re-inject a section's markup on every edit — so the binding is guarded by a flag on `window` and
 * attached to `document` rather than to the elements. Controls added later by the Editor are picked up
 * automatically, with no re-initialisation and no duplicate handlers.
 */
if (!window.__bnqCookieSettingsBound) {
  window.__bnqCookieSettingsBound = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bnq-cookie-settings]');
    if (!trigger) return;

    const banner = window.privacyBanner;

    // No API available — do NOT preventDefault, so the href fallback navigates instead.
    if (!banner || typeof banner.showPreferences !== 'function') return;

    event.preventDefault();
    banner.showPreferences();
  });
}
